import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';

export type UrlByScope = {
  [key in Scope]: string;
};

export const SCOPE_URLS: UrlByScope = {
  '': '',
  // FESTIVAL
  TEAM: 'external/team',
  ARTISTS: 'external/artists',
  PUBLIC: 'external/public',
  PUBLIC_SUPPLIER: 'external/public-supplier',
  // FESTIVAL CATEGORIES
  'TEAM-MOBILITY': 'external/team-mobility',
  'TEAM-CATERING': 'external/team-catering',
  'TEAM-ACCOMMODATION': 'external/team-accommodation',
  'ARTISTS-MOBILITY': 'external/artists-mobility',
  'ARTISTS-CATERING': 'external/artists-catering',
  'ARTISTS-ACCOMMODATION': 'external/artists-accommodation',
  'ARTISTS-CARGO': 'external/artists-cargo',
  'SITE-ENERGY-WATER-WASTE': 'external/site-energy-water-waste',
  'SITE-EQUIPMENT-CARGO': 'external/site-equipment-cargo',
  'SITE-BUILDING': 'external/site-building',
  // VENUE-STRUCTURE
  SITE: 'external/site',
  'VENUE-STRUCTURE-SITE': 'external/venue-structure-site',
  'VENUE-STRUCTURE-TEAM': 'external/venue-structure-team',
  // VENUE-STRUCTURE CATEGORIES
  'VENUE-STRUCTURE-TEAM-TRANSPORT': 'external/venue-structure-team-transport',
  'VENUE-STRUCTURE-TEAM-CATERING': 'external/venue-structure-team-catering',
  'VENUE-STRUCTURE-SITE-SCENOGRAPHY':
    'external/venue-structure-site-scenography',
  'VENUE-STRUCTURE-SITE-MATERIAL': 'external/venue-structure-site-material',
  'VENUE-STRUCTURE-SITE-BUILDING': 'external/venue-structure-site-building',
  'VENUE-STRUCTURE-SITE-ENERGY': 'external/venue-structure-site-energy',
  'VENUE-STRUCTURE-SITE-WATER': 'external/venue-structure-site-water',
  'VENUE-STRUCTURE-SITE-WASTE': 'external/venue-structure-site-waste',
  'VENUE-STRUCTURE-SITE-EQUIPMENT': 'external/venue-structure-site-equipment',
  'VENUE-STRUCTURE-PUBLIC': 'external/venue-structure-public',
  'VENUE-STRUCTURE-PUBLIC-CATERING': 'external/venue-structure-public-catering',
  'VENUE-STRUCTURE-PUBLIC-DIGITAL': 'external/venue-structure-public-digital',
  // VENUE-DATES
  'VENUE-DATES-ARTISTS': 'external/venue-dates-artists',
  // VENUE-DATES CATEGORIES
  'VENUE-DATES-ARTISTS-MOBILITY': 'external/venue-dates-artists-mobility',
  'VENUE-DATES-ARTISTS-CATERING': 'external/venue-dates-artists-catering',
  'VENUE-DATES-ARTISTS-ACCOMMODATION':
    'external/venue-dates-artists-accommodation',
  'VENUE-DATES-ARTISTS-CARGO': 'external/venue-dates-artists-cargo',
  // SURVEY
  'SURVEY-MOBILITY-ACCOMMODATION': 'external/survey-mobility-accommodation',
};
